<div class="p-5">
  @if (!createResponse) {
    <div class="flex flex-col" [formGroup]="formGroup">
      <div class="mb-4 flex flex-row">
        <div>
          <label class="label ml-auto p-0">
            <input
              class="checkbox checkbox-sm mr-2"
              type="checkbox"
              [(ngModel)]="isExistingTenant"
              [ngModelOptions]="{ standalone: true }"
            />
            <span class="label-text">Is An Existing Tenant</span>
          </label>
        </div>
      </div>

      @if (isExistingTenant) {
        <div class="flex flex-row">
          <div class="mr-8 min-w-72 max-w-96">
            <label class="form-control relative w-full pb-4">
              <label class="label">
                <span class="label-text">Account Number</span>
              </label>
              <input
                class="input input-bordered"
                type="text"
                formControlName="accountNumber"
                placeholder="Account Number"
                name="accountNumber"
              />
              @if (accountNumber.invalid && accountNumber.touched) {
                <div class="label">
                  <span class="label-text-alt text-error"
                    >Please enter a valid account number</span
                  >
                </div>
              }
            </label>
          </div>

          <div class="mr-8 min-w-72 max-w-96">
            <label class="form-control relative w-full pb-4">
              <label class="label">
                <span class="label-text">Quickbooks/Avatax ID</span>
              </label>
              <input
                class="input input-bordered"
                type="text"
                formControlName="quickbooksId"
                placeholder="Quickbooks ID"
                name="quickbooksId"
              />
              @if (quickbooksId.invalid && quickbooksId.touched) {
                <div class="label">
                  <span class="label-text-alt text-error"
                    >Please enter a valid quickbooks/avatax id</span
                  >
                </div>
              }
            </label>
          </div>
        </div>
      }

      <div class="mb-4 flex flex-row">
        <div class="mr-8 min-w-72 max-w-96">
          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">Distributor</span>
            </label>
            @if (!loadingDistributors) {
              <select
                class="select select-bordered"
                formControlName="distributor"
              >
                <option value="" disabled selected></option>
                @for (distributor of distributors; track distributor) {
                  <option [value]="distributor.id">
                    {{ distributor.name }}
                  </option>
                }
              </select>
            } @else {
              <div class="skeleton h-12 w-full"></div>
            }
            @if (distributor.invalid && distributor.touched) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please select a distributor</span
                >
              </div>
            }
          </label>
        </div>
        <div class="mr-8 min-w-72 max-w-96">
          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">Franchise (optional)</span>
            </label>
            @if (!loadingFranchises) {
              <select
                class="select select-bordered"
                formControlName="franchise"
              >
                <option value="" selected>(None)</option>
                @for (franchise of franchises; track franchise) {
                  <option [value]="franchise.id">
                    {{ franchise.name }}
                  </option>
                }
              </select>
            } @else {
              <div class="skeleton h-12 w-full"></div>
            }
          </label>
        </div>
        <div class="min-w-72 max-w-96"></div>
      </div>

      <div class="flex flex-row">
        <div class="mr-8 min-w-72 max-w-96">
          <h4>Contact Info</h4>
          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">Company Name</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="companyName"
              placeholder="Company Name"
              name="companyName"
            />
            @if (
              companyName.invalid && (companyName.dirty || companyName.touched)
            ) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter company name</span
                >
              </div>
            }
          </label>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">First Name</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="firstName"
              placeholder="First Name"
              name="firstName"
            />
            @if (firstName.invalid && (firstName.dirty || firstName.touched)) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid first name</span
                >
              </div>
            }
          </label>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">Last Name</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="lastName"
              placeholder="Last Name"
              name="lastName"
            />
            @if (lastName.invalid && (lastName.dirty || lastName.touched)) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid last name</span
                >
              </div>
            }
          </label>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">Email</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="email"
              placeholder="Email"
              name="email"
            />
            @if (email.invalid && (email.dirty || email.touched)) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid email address</span
                >
              </div>
            }
          </label>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">Phone</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="phone"
              placeholder="Phone"
              name="phone"
            />
            @if (phone.invalid && (phone.dirty || phone.touched)) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid phone number</span
                >
              </div>
            }
          </label>
        </div>

        <div class="mr-8 min-w-72 max-w-96">
          <h4>Shipping Address</h4>
          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">Address</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="address"
              placeholder="Address"
              name="address"
              (change)="handleAddressChange()"
            />
            @if (address.invalid && (address.dirty || address.touched)) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid address</span
                >
              </div>
            }
          </label>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">City</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="city"
              placeholder="City"
              name="city"
              (change)="handleAddressChange()"
            />
            @if (city.invalid && (city.dirty || city.touched)) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid city</span
                >
              </div>
            }
          </label>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">State</span>
            </label>
            <select
              class="select select-bordered"
              formControlName="st"
              name="st"
              (change)="handleAddressChange()"
            >
              <option value="" disabled selected></option>
              @for (state of states; track state) {
                <option [value]="state.value">
                  {{ state.value }} - {{ state.display }}
                </option>
              }
            </select>
            @if (st.invalid && (st.dirty || st.touched)) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid state</span
                >
              </div>
            }
          </label>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">Zip</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="zip"
              placeholder="Zip"
              name="zip"
              (change)="handleAddressChange()"
            />
            @if (zip.invalid && (zip.dirty || zip.touched)) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid zip</span
                >
              </div>
            }
          </label>
        </div>

        <div class="min-w-72 max-w-96">
          <div class="flex">
            <h4>Billing Address</h4>
            <label class="label ml-auto p-0">
              <input
                class="checkbox checkbox-sm mr-2"
                type="checkbox"
                [(ngModel)]="billingSameAsAddress"
                [ngModelOptions]="{ standalone: true }"
                (change)="handleBillingSameAsAddressChecked($event)"
              />
              <span class="label-text">Same as shipping</span>
            </label>
          </div>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">Address</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="billingAddress"
              placeholder="Address"
              name="billingAddress"
            />
            @if (
              billingAddress.invalid &&
              (billingAddress.dirty || billingAddress.touched)
            ) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid address</span
                >
              </div>
            }
          </label>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">City</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="billingCity"
              placeholder="City"
              name="billingCity"
            />
            @if (
              billingCity.invalid && (billingCity.dirty || billingCity.touched)
            ) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid city</span
                >
              </div>
            }
          </label>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">State</span>
            </label>
            <select
              class="select select-bordered"
              formControlName="billingSt"
              name="billingSt"
            >
              <option value="" disabled selected></option>
              @for (state of states; track state) {
                <option [value]="state.value">
                  {{ state.value }} - {{ state.display }}
                </option>
              }
            </select>
            @if (billingSt.invalid && (billingSt.dirty || billingSt.touched)) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid state</span
                >
              </div>
            }
          </label>

          <label class="form-control relative w-full pb-4">
            <label class="label">
              <span class="label-text">Zip</span>
            </label>
            <input
              class="input input-bordered"
              type="text"
              formControlName="billingZip"
              placeholder="Zip"
              name="billingZip"
            />
            @if (
              billingZip.invalid && (billingZip.dirty || billingZip.touched)
            ) {
              <div class="label">
                <span class="label-text-alt text-error"
                  >Please enter a valid zip</span
                >
              </div>
            }
          </label>
        </div>
      </div>
    </div>

    <div class="mt-4 flex justify-center">
      <button
        class="btn btn-primary"
        (click)="validateAddress()"
        [disabled]="creatingTenant || createResponse"
      >
        Create New Tenant
      </button>
    </div>
  }

  @if (creatingTenant) {
    <div class="mt-4 flex justify-center">
      <div class="loading-spinner"></div>
    </div>
  }

  @if (createResponse) {
    <div class="mt-4">
      <p class="mb-2 text-center text-success">Tenant created successfully!</p>
      <p class="mb-2 text-center">
        Account Number: {{ createResponse.tenant.account_number }}
      </p>
      <div class="flex justify-center">
        <button
          class="btn btn-primary"
          [routerLink]="'/admin/tenant/' + createResponse.tenant.id"
        >
          View Tenant
        </button>
      </div>
    </div>
    <div class="mt-8 flex justify-center">
      <button class="btn btn-primary" (click)="refreshPage()">
        Create Another Tenant
      </button>
    </div>
  }

  @if (createError) {
    <div class="mt-4">
      <p class="text-center text-error">{{ createError }}</p>
    </div>
  }
</div>

<dialog class="modal" #cassModal>
  <div class="modal-box max-w-3xl">
    <form method="dialog">
      <button class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2">
        ✕
      </button>
    </form>

    <h3 class="text-lg font-bold">Address Validation</h3>

    @if (cassShippingError) {
      <div class="mt-4 text-center text-error">
        <p>{{ cassShippingError }}</p>
      </div>
    } @else if (validatingShippingAddress) {
      <div class="mt-4 text-center">
        <div class="loading loading-spinner"></div>
      </div>
    } @else if (cassShippingResponse && cassShippingInputAddress) {
      <table class="table table-zebra">
        <thead class="text-base">
          <tr>
            <td></td>
            <td class="font-medium">Validated</td>
            <td class="font-medium">Original</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Company</td>
            <td>{{ cassShippingResponse.company }}</td>
            <td>{{ cassShippingInputAddress.company }}</td>
          </tr>
          <tr>
            <td>Address</td>
            <td>{{ cassShippingResponse.address }}</td>
            <td>{{ cassShippingInputAddress.address }}</td>
          </tr>
          <tr>
            <td>City</td>
            <td>{{ cassShippingResponse.city }}</td>
            <td>{{ cassShippingInputAddress.city }}</td>
          </tr>
          <tr>
            <td>State</td>
            <td>{{ cassShippingResponse.state }}</td>
            <td>{{ cassShippingInputAddress.state }}</td>
          </tr>
          <tr>
            <td>Zip</td>
            <td>{{ cassShippingResponse.zip }}</td>
            <td>{{ cassShippingInputAddress.zip }}</td>
          </tr>
          <tr>
            <td>DPV Code</td>
            <td>{{ cassShippingResponse.dpva }}</td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>
              <label class="label justify-start">
                <input
                  class="checkbox checkbox-sm mr-2"
                  type="checkbox"
                  [(ngModel)]="useCassShippingResponse"
                  [ngModelOptions]="{ standalone: true }"
                />
                <span class="label-text">Use validated address</span>
              </label>
            </td>
            <td>
              <label class="label justify-start">
                <input
                  class="checkbox checkbox-sm mr-2"
                  type="checkbox"
                  [checked]="!useCassShippingResponse"
                  (change)="useCassShippingResponse = !useCassShippingResponse"
                />
                <span class="label-text">Use input address</span>
              </label>
            </td>
          </tr>
        </tbody>
      </table>

      @if (
        cassShippingResponse.dpva === '' || cassShippingResponse.dpva === 'N'
      ) {
        <div class="mt-8 text-error">
          We are unable to validate the input address. Are you sure you want to
          use this address?
        </div>
      }
    } @else {
      <div class="text-center text-error">
        <p>Unexpected error validating shipping address</p>
      </div>
    }

    @if (!billingSameAsAddress) {
      <hr />

      @if (cassBillingError) {
        <div class="mt-4 text-center text-error">
          <p>{{ cassBillingError }}</p>
        </div>
      } @else if (validatingBillingAddress) {
        <div class="mt-4 text-center">
          <div class="loading loading-spinner"></div>
        </div>
      } @else if (cassBillingResponse && cassBillingInputAddress) {
        <table class="table table-zebra">
          <thead class="text-base">
            <tr>
              <td></td>
              <td class="font-medium">Validated</td>
              <td class="font-medium">Original</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Address</td>
              <td>{{ cassBillingResponse.address }}</td>
              <td>{{ cassBillingInputAddress.address }}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{{ cassBillingResponse.city }}</td>
              <td>{{ cassBillingInputAddress.city }}</td>
            </tr>
            <tr>
              <td>State</td>
              <td>{{ cassBillingResponse.state }}</td>
              <td>{{ cassBillingInputAddress.state }}</td>
            </tr>
            <tr>
              <td>Zip</td>
              <td>{{ cassBillingResponse.zip }}</td>
              <td>{{ cassBillingInputAddress.zip }}</td>
            </tr>
            <tr>
              <td>DPV Code</td>
              <td>{{ cassBillingResponse.dpva }}</td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>
                <label class="label justify-start">
                  <input
                    class="checkbox checkbox-sm mr-2"
                    type="checkbox"
                    [(ngModel)]="useCassBillingResponse"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <span class="label-text">Use validated address</span>
                </label>
              </td>
              <td>
                <label class="label justify-start">
                  <input
                    class="checkbox checkbox-sm mr-2"
                    type="checkbox"
                    [checked]="!useCassBillingResponse"
                    (change)="useCassBillingResponse = !useCassBillingResponse"
                  />
                  <span class="label-text">Use input address</span>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      } @else {
        <div class="text-center text-error">
          <p>Unexpected error validating billing address</p>
        </div>
      }
    }

    @if (!validatingShippingAddress && !validatingBillingAddress) {
      <div class="flex justify-center space-x-4">
        <div class="mt-8 flex justify-center">
          <button class="btn btn-success" (click)="createTenant()">
            Create Tenant
          </button>
        </div>

        <div class="mt-8 flex justify-center">
          <button class="btn btn-neutral" (click)="closeCassModal()">
            Cancel
          </button>
        </div>
      </div>
    }
  </div>
</dialog>
